import { instance, next } from "./base";

export const getRates = async (type) => {
  const { data } = await instance()
    .get("/api/v1/admin/rates", { params: { type, aggregate: true } })
    .catch((e) => next(e));
  return data?.data;
};

export const createRate = async (values) => {
  const { data } = await instance(true)
    .post("/api/v1/admin/rates", values)
    .catch((e) => next(e));
  return data?.data;
};

export const updateRate = async (values) => {
  const id = values.id;
  delete values.id
  const { data } = await instance()
    .patch(`/api/v1/admin/rates/${id}`, values)
    .catch((e) => next(e));
  return data?.data;
};

export const deleteRate = async (values) => {
  const id = values.id;
  delete values.id
  const { data } = await instance()
    .delete(`/api/v1/admin/rates/${id}`)
    .catch((e) => next(e));
  return data?.data;
};

export const getPlatformRate = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/platform-rate")
    .catch((e) => next(e));
  return data?.data;
};

export const createPlatformRate = async (values) => {
  const { data } = await instance()
    .post("/api/v1/admin/platform-rate", values)
    .catch((e) => next(e));
  return data?.data;
};